import styled from 'styled-components';
import ItemContainer from '../../shared/ItemContainer';

export const StyledContainer = styled(ItemContainer)`
  padding: 0.5rem;
  display: block;
  height: fit-content;
  width: 100%;
`;
